import React from 'react'

export interface ItemIntegrationParamsProps {
  params: { title: React.ReactNode; value: React.ReactNode }[]
}

export function ItemIntegrationParams(props: ItemIntegrationParamsProps) {
  return (
    <div className={'flex flex-col gap-2.5 lg:gap-4'}>
      {props.params.map((param, index) => (
        <div key={index} className={'flex gap-2'}>
          <span>{param.title}:</span>
          <span className={'text-text-primary'}>{param.value}</span>
        </div>
      ))}
    </div>
  )
}
